import { articleUnitsOfMeasureSlice } from "./articleUnitsOfMeasureSlice";
import * as defaultActions from "../../../../../redux/_common";
import { Dispatch } from "redux";

export const QPARAMS_CHANGED = "articleUnitsOfMeasure/QParamsChanged";
const { actions } = articleUnitsOfMeasureSlice;
const moduleUrl = '/api/appmasterdata/articleunitsofmeasure'

export const setValidationErrors = actions.setValidationErrors;

export const getItems = (params: {}) => defaultActions.getItems(moduleUrl, actions, params);
export const getDropDownItems = (params: {}) => defaultActions.getDropDownItems(`${moduleUrl}/select`, actions, params);
export const getItemForEdit = (id: string) => defaultActions.getItem(`${moduleUrl}/${id}`, actions);

export const deleteItem = (id: string) => defaultActions.deleteItem(`${moduleUrl}/${id}`, actions);

export const saveItem = (item: {}, id: string | null) =>
  defaultActions.saveItem(
      moduleUrl,
      actions,
      item,
      id,
  );


export const setActiveMeasures = (measures:any[]) => (dispatch:Dispatch) => {
  dispatch(actions.setActiveMeasures(measures));
}

export const clearItem = () => defaultActions.clearItem(actions);
export const clear = () => defaultActions.clearAll(actions);
export const clearError = () => defaultActions.clearErrors(actions);